import LifecycleServices from "pluginServices/services/LifecycleServices";
import InteractiveService from "services/InteractiveService";
import { EDITOR } from "pluginServices/constants";
import { INTERACTIVE } from "pluginServices/constants/coursewareTypes";
import { stage } from "../keyPaths";
import { CDP } from 'pluginServices';
import { EVENT_NAMES, ACTIONS } from 'services/UndoRedoService/constants/undoRedo';
import { computeSectionReselection, updateConfigs, restoreAnnotationsAttached, deleteAnnotationsAttached } from "../utils";

const removeComponentsFromInteractive = async (action, elementId) => {
  const componentIds = action.data.map((component) => component.itemId);
  const element = await InteractiveService.getInteractive(elementId);

  const updatedComponents = element.config.components.filter(
    (component) => !componentIds.includes(component.itemId)
  );

  element.config.components = updatedComponents;
  await InteractiveService.saveInteractiveConfig(elementId, element.config);
};

export const deleteComponents = async ({ annotations, ...action }, eventType, previousConfig) => {

  const lifecycleServices = new LifecycleServices({
    context: EDITOR,
    id: previousConfig.elementId,
    coursewareType: INTERACTIVE,
  });

  const components = action.data;
  const noOfComponents = components.length;

  const deleteChildren = async () => {
    const componentIds = components.map(((component) => component.itemId));
    return lifecycleServices.deleteChildren(componentIds);
  };

  const saveInInteractiveConfig = async () => InteractiveService.saveInInteractiveConfig(previousConfig.elementId, stage, previousConfig.config);

  const removeComponents = async () => removeComponentsFromInteractive(action, previousConfig.elementId);

  const deleteComponentsServiceCalls = [
    ...noOfComponents ? [deleteChildren] : [],
    ...noOfComponents ? [removeComponents] : [],
    saveInInteractiveConfig,
  ];

  await deleteComponentsServiceCalls.reduce(async (previousPromise, nextPromise) => previousPromise.then(() => nextPromise()), Promise.resolve());
  if (annotations?.annotationIds.length) {
    await deleteAnnotationsAttached(annotations);
  }
};

export const updateScreenPostConfigChanges = (action, eventType) => {
  switch (action.name) {
    case EVENT_NAMES.MOVE_SECTION:
      CDP.editor().select(computeSectionReselection(action, eventType));
      break;
    case EVENT_NAMES.PASTE_ELEMENTS:
    case EVENT_NAMES.PASTE_COMPONENTS:
      eventType === ACTIONS.REDO && action.editorState && CDP.editor().select(action.editorState);
      break;
    default:
      break;
  }
};

const appendToComponents = async (action, elementId) => {
  const element = await InteractiveService.getInteractive(elementId);
  action.data.forEach((components) => element.config.components.push(components));
  await InteractiveService.saveInteractiveConfig(elementId, element.config);
};


export const restoreComponents = async ({ annotations, ...action }, eventType, previousConfig) => {
  const lifecycleServices = new LifecycleServices({
    context: EDITOR,
    id: previousConfig.elementId,
    coursewareType: INTERACTIVE,
  });
  const componentIds = action.data.map((component) => component.itemId);
  if (componentIds.length) {
    await lifecycleServices.restoreComponents(componentIds);
  }
  await InteractiveService.saveInInteractiveConfig(previousConfig.elementId, stage, previousConfig.config);
  if (annotations?.annotationIds.length) {
    await restoreAnnotationsAttached(annotations);
  }
  await appendToComponents(action, previousConfig.elementId);
  updateScreenPostConfigChanges(action, eventType);
};

export const moveElements = async (action, eventType, previousConfig) => {

  const { originalScreenId,
    destinationScreenId,
    destinationSectionRef,
    destinationSection,
    componentIds,
    componentsData } = action.data;

  let { config: originalScreenConfig, parentPathwayId: originalScreenPathwayId } = await InteractiveService.getInteractive(originalScreenId, null, false);
  let { config: destinationScreenConfig, parentPathwayId: destinationScreenPathwayId } = await InteractiveService.getInteractive(destinationScreenId, null, false);

  if (eventType === ACTIONS.UNDO) {
    originalScreenConfig.stage = previousConfig.config;
    destinationScreenConfig.stage.sections = destinationScreenConfig.stage.sections?.filter((section) => section.ref !== destinationSectionRef);

    await updateConfigs(destinationScreenId, originalScreenId, destinationScreenConfig, originalScreenConfig, destinationScreenPathwayId, originalScreenPathwayId, componentsData, componentIds);

  } else if (eventType === ACTIONS.REDO) {
    originalScreenConfig.stage = previousConfig.config;
    destinationScreenConfig.stage.sections.push(destinationSection);

    await updateConfigs(originalScreenId, destinationScreenId, originalScreenConfig, destinationScreenConfig, originalScreenPathwayId, destinationScreenPathwayId, componentsData, componentIds);
  }
};